import React, { useState, useMemo } from "react";
import Radio from "@material-ui/core/Radio";
import PropTypes from "prop-types";
import uuidv4 from "uuid/v4";
import { Tooltip } from "reactstrap";
import "./css/index.scss";

const RadioButton = ({
  value,
  isSelected,
  onChange,
  tooltipPosition,
  tooltipText,
  wrapperClassName,
  disabled
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const uuid = useMemo(() => `t${uuidv4().replace(/-/g, "")}`, []);
  return (
    <div onMouseEnter={toggle} onMouseLeave={toggle} id={uuid} className={wrapperClassName}>
      <Radio disabled={disabled} checked={isSelected} onChange={onChange} value={value} />
      {tooltipText && (
        <Tooltip placement={tooltipPosition} isOpen={isOpen} target={uuid} toggle={toggle}>
          {tooltipText}
        </Tooltip>
      )}
    </div>
  );
};

RadioButton.propTypes = {
  disabled: PropTypes.bool,
  value: PropTypes.string,
  isSelected: PropTypes.bool,
  onChange: PropTypes.func,
  tooltipPosition: PropTypes.string,
  tooltipText: PropTypes.string,
  wrapperClassName: PropTypes.string
};

RadioButton.defaultProps = {
  disabled: false,
  value: "0",
  isSelected: false,
  onChange: () => {},
  tooltipPosition: "top",
  tooltipText: "",
  wrapperClassName: ""
};
export default RadioButton;
